import { useEffect, useState } from 'react';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import { useAppContext } from '../../../Services/AppContext';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { useIsLatam } from '../../Region/Services/region.service';
import HealthPlanDiagnosticImagingBabyLatam from '../Components/HealthPlanDiagnosticImaging/HealthPlanDiagnosticImagingBabyLatam';
import HealthPlanDiagnosticImagingDiabetesLatam from '../Components/HealthPlanDiagnosticImaging/HealthPlanDiagnosticImagingDiabetesLatam';
import { FormHookCountry, FormHookResult } from './FormHook.interface';

const HealthPlanDiagnosticImagingForms: FormHookCountry = {
	latam: {
		meddibaby: HealthPlanDiagnosticImagingBabyLatam,
		diabetes: HealthPlanDiagnosticImagingDiabetesLatam,
	},
	// TODO Add actual forms in case country is not latam
	default: {
		meddibaby: HealthPlanDiagnosticImagingBabyLatam,
		diabetes: HealthPlanDiagnosticImagingDiabetesLatam,
	},
};

const useHealthPlanDiagnosticImagingForm = (): FormHookResult => {
	const { globalTemplate } = useAppContext();
	const { healthPlan } = useHealthPlanContext();
	const [form, setForm] = useState<ItemScheme[]>(
		HealthPlanDiagnosticImagingForms.default[
			healthPlan.code ?? HealthPlanCode.DIABETES
		],
	);
	const isLatam = useIsLatam(globalTemplate);

	useEffect(() => {
		const formScheme =
			HealthPlanDiagnosticImagingForms[isLatam ? 'latam' : 'default'][
				healthPlan.code ?? HealthPlanCode.DIABETES
			];
		setForm(formScheme);
	}, [healthPlan.code, isLatam]);

	return {
		formScheme: form,
	};
};

export default useHealthPlanDiagnosticImagingForm;
